import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import OptionSelector from "./components/OptionSelector";
import ChatBox from "./components/ChatBox";
import Dashboard from "./components/Dashboard";
import { chatConcepts, chatBudget, getCompanies } from "./api";

function App() {
  const [mode, setMode] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [conversationId, setConversationId] = useState(null);
  const [userName, setUserName] = useState("");
  const [loading, setLoading] = useState(false);

  // --------------------------------------------------
  // THEME: Light / Dark / Custom + Persistencia
  // --------------------------------------------------
  const [themeMode, setThemeMode] = useState(() => {
    return localStorage.getItem("themeMode") || "light";
  });

  const [bgColor, setBgColor] = useState(() => {
    return localStorage.getItem("bgColor") || "#ffffff";
  });

  // Cambiar tema y persistir
  useEffect(() => {
    localStorage.setItem("themeMode", themeMode);

    if (themeMode === "light") {
      setBgColor("#ffffff");
      localStorage.setItem("bgColor", "#ffffff");
    }

    if (themeMode === "dark") {
      setBgColor("#1e1e1e");
      localStorage.setItem("bgColor", "#1e1e1e");
    }

    if (themeMode === "custom") {
      // bgColor queda como está
      localStorage.setItem("bgColor", bgColor);
    }
  }, [themeMode]);

  // Guardar cambios de color personalizado
  useEffect(() => {
    if (themeMode === "custom") {
      localStorage.setItem("bgColor", bgColor);
    }
  }, [bgColor]);


  // Selector de tema (light <-> dark)
  const toggleDarkMode = () => {
    if (themeMode === "light") setThemeMode("dark");
    else setThemeMode("light");
  };

  // Cambiar a tema custom
  const enableCustomTheme = () => {
    setThemeMode("custom");
  };

  // --------------------------------------------------
  // Lógica original de tu aplicación
  // --------------------------------------------------

  const fetchCompanies = async (attempt = 1) => {
    setLoading(true);
    try {
      const res = await getCompanies();
      if (!res.data || res.data.length === 0) {
        if (attempt < 3) return fetchCompanies(attempt + 1);
      } else {
        setCompanies(res.data.companies || res.data);
      }
    } catch (err) {
      console.error("Error fetching companies:", err);
      if (attempt < 3) return fetchCompanies(attempt + 1);
    } finally {
      setLoading(false);
    }
  };

  const handleUserName = (name) => {
    setUserName(name);
    if (!conversationId) setConversationId(uuidv4());
  };

  const goBack = () => {
    setMode(null);
  };

  const handleOptionSelect = async (option) => {
    setMode(option);
    if (option === "companies") await fetchCompanies();
  };

const sendMessage = async (message) => {
  if (!userName) return alert("Please, set your name");

  const payload = {
    query: message,
    userName,
    conversationId,
    responseLevel: "breve",
  };

  try {
    let res;

    if (mode === "concepts") {
      res = await chatConcepts(payload);
    }

    if (mode === "budget") {
      res = await chatBudget(payload);
    }

    setConversationId(res.data.conversationId || conversationId);
    return res.data.answer;
  } catch (err) {
    console.error("Front-end error:", err);

    // ****************************
    // MANEJO DE ERRORES GEMINI
    // ****************************
    if (err.response) {
      const apiError = err.response.data;

      // Si viene el error personalizado desde GeminiApiException
      if (apiError.error) {
        return `❌ *Error desde IA:* \n${apiError.error}`;
      }

      // Si viene de validación (ej: approved = false)
      if (apiError.message) {
        return `⚠️ *Advertencia:* ${apiError.message}`;
      }
    }

    return "❌ An unexpected error occurred.";
  }
};


  // --------------------------------------------------
  // Render principal
  // --------------------------------------------------
  return (
    <div
      style={{
        backgroundColor: bgColor,
        minHeight: "100vh",
        transition: "background 0.3s ease",
        padding: "30px",
        display: "flex",
        justifyContent: "center",
        gap: "50px",
      }}
    >
      {/* ------------------------------ */}
      {/* Theme Controls - Arriba izquierda */}
      {/* ------------------------------ */}
      <div style={{ position: "fixed", top: 10, left: 10, zIndex: 9999 }}>
        {/* Switch Light / Dark */}
        <label style={{ display: "flex", alignItems: "center", gap: "10px", cursor: "pointer", fontWeight: "bold", color: themeMode === "dark" ? "white" : "black" }}>
          <input
            type="checkbox"
            checked={themeMode === "dark"}
            onChange={toggleDarkMode}
          />
          Dark Mode
        </label>

        {/* Botón activar tema personalizado */}

        {/* <button
          onClick={enableCustomTheme}
          style={{
            marginTop: "10px",
            padding: "5px 10px",
            cursor: "pointer",
            borderRadius: "6px",
            border: "1px solid #ccc",
          }}
        >
          Custom
        </button> */}

        {/* Selector de color SOLO si está en modo custom */}
        {themeMode === "custom" && (
          <input
            type="color"
            value={bgColor}
            onChange={(e) => setBgColor(e.target.value)}
            style={{
              width: "45px",
              height: "45px",
              marginTop: "10px",
              cursor: "pointer",
              border: "none",
            }}
          />
        )}
      </div>

  
    {!mode && (
  <OptionSelector 
    onSelect={handleOptionSelect}
    themeMode={themeMode}
  />
)}

      {mode === "companies" && (
        <Dashboard
          companies={companies}
          goBack={goBack}
          fetchCompanies={fetchCompanies}
          loading={loading}
        />
      )}

      {(mode === "concepts" || mode === "budget") && (
        <ChatBox
          sendMessage={sendMessage}
          userName={userName}
          handleUserName={handleUserName}
          selectedOption={mode}
          goBack={goBack}
        />
      )}
    </div>
  );
}

export default App;
